module.exports = __webpack_public_path__ + "img/dash-icon5.c095927f.png";